<div
  class="d-sm-block border-top pt-3"
  [class.d-none]="!show">
  <ng-content></ng-content>
</div>
